<template>
  <div class="d-flex flex-column font-size-13 ">
    <div class="text-capitalize">{{ getText() }}</div>
    <div class="fw-semibold text-center"> {{ JSON.parse(content.params).question }}</div>
    <div v-for="(item,index) in groupContent" :key="index">
      <div style="background-color: #f7f8f9" class="d-flex align-items-center bg-gray mt-1 rounded ">
        <div class="ms-1 flex-1 me-4">{{ item.content }}</div>
        <div class="ms-4">{{ item.votes }}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ChatPoll",
  props: ["content", "conversationId", "accountId"],
  data() {
    return {
      groupContent: []
    };
  },
  watch: {
    content: function() {
      this.getGroupContent();
    }
  },
  methods: {
    getGroupContent() {
      let pollId = JSON.parse(this.content.params).pollId.toString();
      this.$http.get("/api/message/pollDetail", {
        params: {
          accountId: this.accountId,
          pollId: pollId
        }
      }).then((resp) => {
        this.groupContent = resp.data.data.options;
      });
    },
    getText() {
      let text = JSON.parse(this.content.params).msg.vi;
      if (text.length > 8) return text.slice(4, -4);
      return text;
    }
  },
  created() {
    this.getGroupContent();
  }
};
</script>

<style scoped>

</style>